import { render, staticRenderFns } from "./SidebarFields.vue?vue&type=template&id=b4ecc988&scoped=true&"
import script from "./SidebarFields.vue?vue&type=script&lang=js&"
export * from "./SidebarFields.vue?vue&type=script&lang=js&"
import style0 from "./SidebarFields.vue?vue&type=style&index=0&id=b4ecc988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ecc988",
  null
  
)

export default component.exports